<template>
  <div style="width:800px;height:800px;position:absolute;left:50%;top:50%;margin-left:-400px;margin-top:-400px;">
    <div class="login-content-box">
      <div class="login-content-box-1">
        <div class="login-content-box-1-top">
          <div class="f-tac" style="width:100%">
            <img src="@static/img/logo.png" style="display:inline-block;">
          </div>
          <p class="p2">展商登录</p>
        </div>
        <div class="login-content-box-1-bottom">
          <Form class="F" ref="formInline" :model="formInline" :rules="ruleInline" @keyup.enter.native="handleSubmit('formInline')">
            <FormItem class="F-1" prop="user">
              <Input class="I" type="text" v-model="formInline.user" placeholder="用户名" prefix="md-contact" />
            </FormItem>
            <FormItem class="F-1" prop="password">
              <Input class="I" type="password" v-model="formInline.password" placeholder="密码" prefix="md-lock" />
            </FormItem>
            <FormItem class="F-1" prop="captcha">
              <Input class="I" v-model="formInline.captcha" placeholder="验证码" prefix="md-mail-open" />
              <img class="code" :src="code.image" alt="验证码" v-if="code && code.image" @click="getCode" />
            </FormItem>
            <div class="F-2">
              <Checkbox class="save-btn" v-model="remember">&nbsp;&nbsp;&nbsp;记住我</Checkbox>
              <p class="F-2-text" style="font-size:14px;width:60px;color:#515a6e;" @click="resetShow1=true;">忘记密码</p>
            </div>
            <Button type="primary" @click="handleSubmit('formInline')" size="large" :loading="loading">登录</Button>
            <!-- <Button class="wx-btn" @click="$router.push('clogin')" size="large">
            <span class="wx-icon">
              <img src="../img/weixin.png" alt="微信" />
            </span>微信扫码登录
          </Button>-->
          </Form>
        </div>
      </div>
    </div>
    <!-- <div class="login-content-text">
      <h3>展商中心</h3>
      <p>尊敬的展商，欢迎参加中国国际焙烤展展会</p>
      <p>请登录进入展商中心，完善您的企业、产品信息</p>
      <p>您填写的每一个文字都将在线上线下为您的企业宣传发挥价值！</p>
    </div> -->

    <iModal title="找回密码" @on-cancel="cancel" v-model="resetShow1">
      <Form ref="formReset1" :model="formReset1" :rules="ruleReset1" inline :label-width="120">
        <FormItem label="手机号码：" prop="phone">
          <Input type="text" style="width:300px;" v-model="formReset1.phone" placeholder="请输入手机号码" />
        </FormItem>
        <FormItem label="验证码：" prop="captcha">
          <Input type="text" style="width:180px;margin-right:20px;" v-model="formReset1.captcha" placeholder="请填写验证码" />
          <Button v-if="showCode" @click="getCaptcha('formReset1')" style="width: 100px;">获取验证码</Button>
          <Button v-else disabled style="width: 100px;padding:0;">{{count}}s后重新获取</Button>
        </FormItem>
      </Form>
      <div slot="footer">
        <Button type="primary" @click="cancel">取消</Button>
        <Button type="primary" @click="reset('formReset1')">确认</Button>
      </div>
    </iModal>

    <!-- 修改密码modal -->
    <iModal title="修改密码" @on-cancel="cancel2" v-model="resetShow2" class-name="newPas" :closable="false">
      <Form ref="formReset2" :model="formReset2" :rules="ruleReset2" inline :label-width="120">
        <FormItem label="新密码：" prop="newPhone">
          <Input type="text" style="width:300px;" v-model="formReset2.newPhone" placeholder="请输入新密码" />
        </FormItem>
      </Form>
      <div slot="footer">
        <Button type="primary" @click="cancel2">取消</Button>
        <Button type="primary" @click="reset2('formReset2')">确认</Button>
      </div>
    </iModal>

    <iModal style="width: 600px;" v-model="modelRemind" title="提示" class-name="vertical-center-modal" :footer-hide="true">
      <div style="margin:10px 15px 15px;">
        i中国国际焙烤展是国药励展中国国际焙烤展唯一官方出品“全球医疗健康产业线上空间”，主要提供中国国际焙烤展展商及产品的搜索、供需发布及对接、商务洽谈、获取门票等在线服务。请认准i中国国际焙烤展官方网站（i.cmef.com.cn）及小程序（“i中国国际焙烤展” ） ，谨防诈骗，避免不必要的损失。
      </div>
      <div class="button" @click="modelRemind=false">
        确认
      </div>
    </iModal>

  </div>
</template>

<script>
import CryptoJS from "crypto-js";
import { mapActions, mapMutations, mapGetters } from "vuex";
import config from "@assets/config.json";

export default {
  data () {
    return {

      modelRemind: false,
      resetShow1: false,
      resetShow2: false,
      showCode: true, // 是否可以获取验证码
      count: "", // 获取验证码的秒数
      formReset1: {
        phone: "",
        captcha: ""
      },
      ruleReset1: {
        phone: [{ required: true, message: "请输入手机号码", trigger: "blur" }],
        captcha: [{ required: true, message: "请输入验证码", trigger: "blur" }],
      },
      formReset2: {
        newPhone: "",
      },
      ruleReset2: {
        newPhone: [{ required: true, message: "密码不能为空", trigger: "blur" },
        {
          type: "string",
          min: 4,
          message: "密码不能小于4位",
          trigger: "blur"
        },
        {
          type: "string",
          max: 50,
          message: "密码不能大于50位",
          trigger: "blur"
        }
        ],
      },
      passedPhone: "",
      passedCaptcha: "",

      formInline: {
        user: "",
        password: "",
        // user: "YAMII",
        // password: "888888",
        // user: "leeeeee",
        // password: "ly19930124",
        captcha: ""
      },
      ruleInline: {
        user: [{ required: true, message: "用户为必填选项", trigger: "blur" }],
        password: [
          { required: true, message: "账号或密码错误", trigger: "blur" },
          {
            type: "string",
            min: 4,
            message: "密码不能小于4位",
            trigger: "blur"
          },
          {
            type: "string",
            max: 50,
            message: "密码不能大于50位",
            trigger: "blur"
          }
        ],
        captcha: [{ required: true, message: "验证码必填", trigger: "blur" }]
      },
      code: null, // 二维码信息
      remember: false, // 记住我
      loading: false,
      exhibitionId: "",
    };
  },
  async created () {
    this.getCode();
    this.init();
  },
  computed: {
    ...mapGetters({
      company: "loginModule/getCompany"
    }),
    // exhibitionId() {
    //   return config.ExhibitionId;
    // },
    ExhibitionIdArr () {
      return config.ExhibitionIdArr;
    }
  },
  methods: {
    ...mapMutations({
      setRole: "setRole",
      setUser: "setUser",
      setToken: "setToken",
      setTokenTime: "setTokenTime",
      setLogin: "setLogin",
      setCompany: "loginModule/setCompany",
      setExhibition: "loginModule/setExhibition",
      setJoinInfo: "loginModule/setJoinInfo"
    }),
    ...mapActions({
      getUser: "loginModule/getUser",
      getToken: "loginModule/getToken",
      getCompany: "loginModule/getCompany",
      getImgCode: "loginModule/getImgCode",
      validateImgCode: "loginModule/validateImgCode",
      getExhibitionById: "exhibitionModule/getExhibitionById",
      getDefaultJoinExhibition: "companyModule/getDefaultJoinExhibition",
      getJoinInfo: "loginModule/getJoinInfo",
      getExIdByUserId: "loginModule/getExIdByUserId",
      getVerCode: "companyModule/getVerCode",
      asyncVerCode: "companyModule/asyncVerCode",
      editVerCode: "companyModule/editVerCode"
    }),
    init () {
      let name = this.$cookies.get('name');
      let pwd = this.$cookies.get('pwd');
      if (name && pwd) {
        let password = CryptoJS.AES.decrypt(pwd, "GY-key").toString(CryptoJS.enc.Utf8);
        // console.log("解密结果：" + password);
        this.remember = true;
        this.formInline.user = name;
        this.formInline.password = password;
      }
    },
    cancel () {
      this.resetShow1 = false;
      this.formReset1.phone = "",
        this.$refs.formReset1.resetFields();
    },
    cancel2 () {
      this.resetShow2 = false;
      this.formReset2.newPhone = "",
        this.$refs.formReset2.resetFields();
    },
    async getCaptcha (name) {
      let valid = await this.validField();
      if (valid) return;
      this.downTime(name);
    },
    async downTime (name) {
      let info = await this.getVerCode({
        Phone: this.formReset1.phone
      });
      if (!info || !info.successed) {
        if (info.errors[0].description) {
          this.$Message.warning(info.errors[0].description);
        } else {
          this.$Message.warning("获取验证码失败，请重试！");
        }
        return;
      }
      this.$Message.success("验证码已发送！");
      const TIME_COUNT = 60;
      if (!this.timer) {
        this.count = TIME_COUNT;
        this.showCode = false;
        this.timer = setInterval(() => {
          if (this.count > 0 && this.count <= TIME_COUNT) {
            this.count--;
          } else {
            this.showCode = true;
            clearInterval(this.timer);
            this.timer = null;
          }
        }, 1000);
      }
    },
    async reset (name) {
      let valid = await this.validForm(name);
      if (!valid) return;
      let req = {
        Phone: this.formReset1.phone,
        token: this.formReset1.captcha
      }
      let bool = await this.asyncVerCode(req);
      if (!bool || !bool.successed) {
        if (bool.errors[0].description) {
          this.$Message.warning(bool.errors[0].description);
        } else {
          this.$Message.warning("验证码错误，请重试！");
        }
        return;
      }
      this.passedPhone = this.formReset1.phone;
      this.passedCaptcha = this.formReset1.captcha;
      this.cancel();
      this.resetShow2 = true;
    },
    async reset2 (name) {
      let valid = await this.validForm(name);
      if (!valid) return;
      let req = {
        Phone: this.passedPhone,
        Token: this.passedCaptcha,
        NewPassword: this.formReset2.newPhone,
      }
      let bool = await this.editVerCode(req);
      if (bool && bool.successed) {
        this.$Message.success("修改成功！");
        this.cancel2();
      } else {
        if (bool.errors[0].description) {
          this.$Message.warning(bool.errors[0].description);
        } else {
          this.$Message.warning("修改失败，请重试！");
        }
      }
    },
    async handleSubmit (name) {
      let form = this.formInline;
      let valid = await this.validForm(name);
      if (!valid) return;
      let codeValid = await this.validCode();
      if (!codeValid) return;
      let formData = {
        grant_type: "password",
        client_id: "cloud.exhibition",
        client_secret: "secret",
        username: form.user,
        password: form.password,
        scope: "synair offline_access"
      };
      this.loading = true;
      setTimeout(c => {
        this.loading = false;
      }, 5000);
      let tokenData = await this.getToken(formData);
      if (tokenData) {
        this.setRole(0);
        this.setToken(tokenData.access_token);
        this.setTokenTime(tokenData.expires_in * 1000 + new Date().getTime());
        let user = await this.getUser();
        let company = await this.getCompany(user.id);
        if (!company) {
          // this.$router.push("/exhibition/register-company");
          this.$Message.warning("未绑定公司信息！");
          return;
        } else {
          this.setCompany(company);
          console.log("公司信息：", company, user);
          let idInfo = await this.getExIdByUserId(user.id);
          if (idInfo && idInfo.ExhibitionId) {
            console.log('this.ExhibitionIdArr', this.ExhibitionIdArr);
            console.log('this.ExhibitionIdArr', idInfo.ExhibitionId);
            if (this.ExhibitionIdArr.indexOf(idInfo.ExhibitionId.toUpperCase()) !== -1) {
              this.exhibitionId = idInfo.ExhibitionId;
              // let exhibition = await this.getDefaultJoinExhibition(company.id);
              let exData = await this.getExhibitionById(this.exhibitionId);
              this.setExhibition(exData);
              console.log("展会信息：", exData);
              this.setLogin(true);
              let joinInfo = await this.getJoinInfo({
                ExhibitionId: this.exhibitionId
              });
              if (joinInfo) {
                this.setJoinInfo(joinInfo.info);
                // 保存密码
                if (this.remember) {
                  let pwd = CryptoJS.AES.encrypt(String(form.password), "GY-key").toString();
                  // console.log("加密结果"+ pwd);
                  this.$cookies.set("name", form.user, 60 * 60 * 24 * 7);
                  this.$cookies.set("pwd", pwd, 60 * 60 * 24 * 7);
                } else {
                  this.$cookies.remove("name");
                  this.$cookies.remove("pwd");
                }
                this.$Message.success("登录成功");
                this.$router.push("/exhibition/index/home");
              } else {
                this.$Message.warning("未绑定展会信息！");
              }
            } else { 
              this.$Message.warning("未绑定展会信息！！");
            }
          } else {
            this.$Message.warning("未绑定展会信息！！！");
          }
        }
      }
      this.loading = false;
    },
    async getCode () {
      // 获取code
      this.code = await this.getImgCode();
    },
    validForm (name) {
      // 验证表单
      return new Promise((resolve, reject) => {
        this.$refs[name].validate(valid => {
          resolve(valid);
        });
      });
    },
    validField (name) {
      // 验证单个表单
      return new Promise((resolve, reject) => {
        this.$refs.formReset1.validateField('phone', valid => {
          resolve(valid);
        });
      });
    },
    async validCode () {
      // 验证code
      if (!this.code || !this.formInline.captcha) return false;
      let valid = await this.validateImgCode({
        Key: this.code.key,
        Code: this.formInline.captcha
      });
      if (!valid) {
        this.$Message.error("验证未通过!");
        return false;
      }
      if (valid.errors && valid.errors[0]) {
        this.$Message.error(valid.errors[0].description);
        this.getCode();
        return false;
      }
      return true;
    },
    linkHost () {
      location.href = "/#/host/login/alogin";
    }
  }
};
</script>

<style lang="scss" scoped>
.login-content-box {
  width: 360px;
  height: 500px;
  background-color: #fff;
  border-radius: 2px;
  position: absolute;
  left: 50%;
  margin-left: -180px;
  display: flex;
  align-items: center;
  justify-content: center;
  &-1 {
    width: 360px;
    height: 500px;
    background-color: #fff;
    box-shadow: 0px 0px 10px 0px rgba(139, 140, 140, 0.3);
    border-radius: 2px;
    position: relative;
    &-top {
      width: 263px;
      // height: 40px;
      position: absolute;
      top: 20px;
      left: 43px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      flex-wrap: wrap;
      .p1 {
        width: 91px;
        height: 17px;
        font-size: 18px;
        line-height: 16px;
        color: #808080;
        cursor: pointer;
        font-weight: bold;
      }
      .p2 {
        width: 100%;
        text-align: center;
        height: 19px;
        font-size: 18px;
        line-height: 16px;
        color: #b10042;
        cursor: pointer;
        font-weight: bold;
        font-size: 24px;
        color: #333;
      }
      .p3 {
        color: #808080;
        &:hover {
          color: #b10042;
        }
      }
    }
    &-bottom {
      width: 300px;
      height: 350px;
      position: absolute;
      top: 160px;
      left: 29px;
    }
  }
  .wx-icon {
    width: 22px;
    height: 22px;
    padding: 3px 5px;
    background-color: #3eb135;
    border-radius: 50%;
    display: inline-block;
    margin-right: 8px;
    img {
      width: 13px;
      height: 11px;
    }
  }
}
.F {
  display: flex;
  flex-direction: column;
  width: 300px;
  height: 350px;
  position: relative;
  &-1 {
    margin-top: 15px;
    margin-bottom: 0;
    .I {
      margin-top: 19px;
    }
  }
  .F-2 {
    width: 100%;
    height: 15px;
    line-height: 15px;
    display: flex;
    justify-content: space-between;
    margin: 24px 0;
    .F-2-text {
      width: 48px;
      height: 13px;
      font-size: 12px;
      color: #333;
      cursor: pointer;
    }
  }
  .wx-btn {
    margin-top: 20px;
  }
  .code {
    width: 70px;
    height: 26px;
    position: absolute;
    top: 22px;
    right: 8px;
    cursor: pointer;
  }
}
.login-content-text {
  position: absolute;
  left: -25%;
  bottom: 48%;
  color: #b10042;
  h3 {
    font-size: 50px;
    margin-bottom: 80px;
  }
  p {
    font-size: 20px;
    font-weight: bold;
  }
}
/deep/ .newPas {
  .ivu-modal-body {
    padding: 24px 0 0 16px;
  }
}
/deep/ .vertical-center-modal {
  display: flex;
  align-items: center;
  justify-content: center;

  .ivu-modal {
    top: 0;
  }
}
.button {
  width: 120px;
  height: 40px;
  background-color: #b10042;
  border-radius: 4px;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 20px auto 40px;
  margin-bottom: 10px;
  cursor: pointer;
}
</style>